import { $data, $find } from 'fxdom/es';
import { drawProductFace } from '../../../../../Maker/F/draw_product_faces.js';

export const drawThumbnail = (product_face_el) => {
  if (!product_face_el.dataset.fxJson) return;
  const product_face = $data(product_face_el);
  const canvas = $find('canvas')(product_face_el);
  product_face_el.dataset.product_face = null;
  drawProductFace(canvas, product_face, false, false, false, false);
};

/**
 * POD 합성 이미지가 zoom 0.4 이상인 경우에 업스케일링을 원한다면 아래 함수를 사용하여 캔버스 이미지를 그려준다.
 */
export const drawUpscalingThumbnail = (product_face_el) => {
  if (!product_face_el.dataset.fxJson) return;
  const product_face = $data(product_face_el);
  const canvas = $find('canvas')(product_face_el);
  product_face_el.dataset.product_face = null;
  const is_upscaling = product_face_el.dataset.is_upscaling !== undefined;
  drawProductFace(canvas, product_face, false, false, false, false, false, is_upscaling);
};
